import React, { Component } from 'react';
import { Form } from 'antd'

import ButtonCustom from '../../components/default/ButtonCustom'
import DisplayInfo from '../../components/default/display-info/DisplayInfo'
import DisplayDataInfo from '../../components/default/display-info/DisplayDataInfo'
import SocialShare from '../../components/SocialShare'
import Gallery from '../../components/Gallery'
import ModalCustom from '../../components/ModalCustom'
import InputCustom from '../../components/default/InputCustom'
import TextAreaCustom from '../../components/default/TextAreaCustom'

import { connect } from 'react-redux'
import { fetchProduct, sendMessage } from '../../actions/product'

const serialize = params => Object.keys(params)
    .map(param => `${param}=${encodeURIComponent(params[param].trim())}`)
    .join('&');

class InnovetionsDetails extends Component {
    state = {
        openMessageModal: false,
        isOpen: false,
        messageData: {
            title: "",
            email: "",
            message: ""
        }
    }

    componentDidMount = () => {
        const id = this.props.match.params.id
        this.props.fetchProduct(id)
    }

    showMessageModal = () => {
        this.setState({ openMessageModal: true });
    }

    handleMessageModalSubmit = () => {
        this.setState({ openMessageModal: false });
    }

    handleMessageModalCancel = () => {
        this.setState({ openMessageModal: false });
    }

    DisplayImageFile = (type) => {
        switch (type) {
            case "pdf":
                return '/resources/images/ic-pdf.svg'
            case "mp3":
                return '/resources/images/ic-mp3.svg'
            default:
                return '/resources/images/image-pdf-mock.png'
        }
    }

    onModalSubmit = (e) => {
        e.preventDefault()
        const {id} = this.props.product
        let messageData = { ...this.state.messageData }
        this.props.sendMessage({id, messageData})
    }

    onInputChange = (event) => {
        const name = event.target.name
        let messageData = { ...this.state.messageData }
        messageData[name] = event.target.value
        this.setState({messageData: messageData})
    }

    render() {
        if(Object.keys(this.props.product).length > 0){
            const { branch, category, cover, created_day, detail, email, faculty, files,
                 images, name, owner, phone, expertise, research
            } = this.props.product
            return (
                <div className="innovation-detail-page-wrap innovation-details">
                    <div className="innovation-detail-page-title gapb-34">{name}</div>
                    <div className="innovation-image gapb-24">
                        <img src={cover} alt="innovation"/>
                    </div>
                    <div className="gapb-24">
                        <SocialShare
                            shareURL={window.location.href}
                            title={name}
                        />
                    </div>
                    <div className="innovation-info-wrap gapb-24">
                        <div className="innovation-info border">
                            <DisplayInfo color="opacity85-45">
                                <DisplayDataInfo label="สร้าง" value={created_day} />
                                <DisplayDataInfo label="คณะ" value={faculty} />
                                <DisplayDataInfo label="สาขา" value={branch} />
                                <DisplayDataInfo label="ความเชี่ยวชาญ" value={expertise} />
                                <DisplayDataInfo label="ผลงานวิจัย" value={research} />
                                <DisplayDataInfo label="โทรศัพท์" value={phone} />
                                <DisplayDataInfo label="อีเมล" value={email} />
                            </DisplayInfo>
                        </div>
                        <div className="innovation-info">
                            <DisplayInfo color="opacity85-45">
                                <DisplayDataInfo label="หมวดหมู่" value={category} />
                            </DisplayInfo>
                        </div>
                    </div>
                    <div className="innovation-info-wrap gapb-32">
                        <div className="innovation-info">
                            <div className="innovation-info-title gapb-24">พัฒนาโดย</div>
                            <div className="product-owner-list gapb-24">
                                {
                                    owner.map((owner,index) => (
                                        <div className="product-owner-wrap gapb-8 is-row" key={index}>
                                            <div className="product-owner-image gapr-16">
                                                <img src="/resources/images/image-propfile-mock1.png" alt="product owner"/>
                                            </div>
                                            <div className="is-100">
                                                <div className="product-owner-name">{`${owner.title}${owner.name}`}</div>
                                                <div className="product-owner-degree">{owner.education}</div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className="innovation-content-wrap">
                        <div  dangerouslySetInnerHTML={{ __html: detail }}/>
                    </div>
                    {images.length > 0 &&
                     <div className="gallery-wrap gapt-32">
                        <div className="gallery-title">Gallery</div>
                        <Gallery
                            images={images.map((images) => {
                                return { src: images.path }
                            })}
                        />
                    </div>
                    }
                    {files.length > 0 && 
                        <div className="file-wrap">
                            <div className="file-title">ไฟล์อ้างอิง</div>
                            <div className="file-list-wrap">
                            {
                                files.map((file, index) => (
                                    <div className="file-item is-row" key={index}>
                                        <div className="file-item-img gapr-12">
                                            <img src={this.DisplayImageFile(file.extension)} alt="file"/>
                                        </div>
                                        <a className="file-name" href="/">{file.name}</a>
                                    </div>
                                ))
                            }
                            </div>
                        </div>
                    }
                    <div className="contact-owner-button" onClick={this.showMessageModal}>
                        <div className="contact-owner-image">
                            <img src="/resources/images/ic-mail.svg" alt="Icon Mail"/>
                        </div>
                        <div className="contact-owner-text">ติดต่อ</div>
                    </div>
                    <ModalCustom
                        title="ติดต่อผู้พัฒนา"
                        width="480px"
                        visible={this.state.openMessageModal}
                        onOk={this.handleMessageModalSubmit}
                        onCancel={this.handleMessageModalCancel}>
                        <div>
                            <Form onSubmit={this.onModalSubmit}>
                                <InputCustom
                                    label="อีเมล"
                                    placeholder="อีเมล"
                                    size="large"
                                    type="text"
                                    marginBottom="16"
                                    onChange={this.onInputChange}
                                    name="email"
                                    required />
                                <InputCustom
                                    label="หัวข้อ"
                                    placeholder="หัวข้อ"
                                    size="large"
                                    type="text"
                                    marginBottom="16"
                                    required
                                    onChange={this.onInputChange}
                                    name="title" />
                                <TextAreaCustom
                                    label="ข้อความ"
                                    placeholder="ข้อความ"
                                    rows="5"
                                    marginBottom="0"
                                    name="message"
								    onChange={this.onInputChange}
                                />
                                <div className="modal-button">
                                    <ButtonCustom
                                        borderRadius="4"
                                        color="blue"
                                        label="ส่งข้อความ"
                                        fontWeight="large"
                                        size="extra"
                                        className="center"
                                        fontSize={16}
                                        htmlType="submit" />
                                </div>
                            </Form>
                        </div>
                    </ModalCustom>
                </div>
            );
        }else{
            return null
        }
    }
}

const mapStateToProps = (state) => {
    return{
        auth: state.auth,
        user: state.user,
        product: state.product
    }
}

const mapDispatchToProps = {
    fetchProduct,
    sendMessage
}

export default connect(mapStateToProps,mapDispatchToProps)(InnovetionsDetails)
